import {
    Directive,
    HostListener,
    Output,
    EventEmitter,
    OnInit,
} from '@angular/core';
import { BootstrapBreakPoints, detectBreakpoint } from '@dxp/core/helpers';

@Directive({
    selector: '[libBootstrapBreakpoint]',
    standalone: true,
})
export class TelXLBootstrapBreakpointDirective implements OnInit {
    @Output() breakpointChange = new EventEmitter<BootstrapBreakPoints>();

    ngOnInit() {
        this.breakpointChange.emit(detectBreakpoint());
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.breakpointChange.emit(detectBreakpoint());
    }
}
